"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var uuidv4 = require("uuid/v4");
/**
 * Generates an uuid v4 string.
 * @returns An uuidv4 string.
 */
function generateGuid() {
    return uuidv4();
}
exports.generateGuid = generateGuid;
//# sourceMappingURL=protocol-base.js.map